import type { MessageKey } from './en';

/** Arabic UI translations. */
export const ar: Record<MessageKey, string> = {
  'nav.deposits': 'طلبات شحن المحافظ',
  'nav.compliance': 'الامتثال',
  'nav.users': 'المستخدمون',
  'nav.dashboard': 'لوحة التحكم',
  'common.retry': 'إعادة المحاولة',
  'common.refresh': 'تحديث',
  'common.search': 'بحث',
  'common.status': 'الحالة',
  'common.all': 'الكل',
  'common.pending': 'معلّق',
  'common.approved': 'موافق عليه',
  'common.rejected': 'مرفوض',
  'deposits.title': 'طلبات شحن المحافظ',
  'deposits.subtitle': 'راجع طلبات شحن محفظة الوحدات والألعاب واعتمدها أو ارفضها.',
  'deposits.empty': 'لا توجد طلبات شحن',
  'errors.generic': 'حدث خطأ. حاول مرة أخرى.',
};
